module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Buzz-02b65df4b407fbd38afa076ec2f52d3f.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Buzz.mp3
// module id = 50
// module chunks = 0